import { START_LOADER, STOP_LOADER } from "../actionTypes"

export const showLoader = msg => ({
  type: START_LOADER
})

export const hideLoader = msg => ({
  type: STOP_LOADER
})



// WEBPACK FOOTER //
// ./src/store/actions/loader.js